import { GlockeAusIcon, GlockeIcon, MondIcon } from './Icons'

/**
 * Erreichbarkeit und Ruhe eines Mitlesenden — als **ein** Zeichen (#32).
 *
 * Aus dem Betrieb: „wer hat Push-Nachrichten aktiviert, wer pausiert gerade".
 * Es sind zwei Fragen, und sie hängen zusammen, ohne dasselbe zu sein:
 *
 * | Push | Stumm | Zeichen | Was es sagt |
 * |---|---|---|---|
 * | ja | nein | Glocke | kommt an, und sie will es |
 * | ja | ja | Glocke durchgestrichen | könnte ankommen, sie will gerade nicht |
 * | nein | ja | Mond | sie will nicht, und es käme ohnehin nichts |
 * | nein | nein | — | kein Gerät angemeldet; der Normalfall, kein Zustand |
 *
 * **Der letzte Fall bekommt bewusst nichts.** Ein Zeichen für „hat noch nie
 * eingerichtet" stünde bei den meisten und sagte nichts über sie aus —
 * Benachrichtigungen sind freiwillig, und ihr Fehlen ist keine Auffälligkeit.
 *
 * **Push ist geräteweit, nicht je Reise.** Wer irgendwo ein Gerät angemeldet
 * hat, gilt als erreichbar — auch in einer Reise, die er stummgeschaltet hat.
 * Genau das ist die Trennung, um die es geht; die Glocke sagt „erreichbar",
 * nicht „bekommt Nachrichten aus dieser Reise".
 *
 * **Ein Bauteil für zwei Listen.** Es steht in der Reiseansicht bei jedem
 * Leser und auf der Reiseseite in der Teilnehmerliste. Zwei Fassungen wären
 * der Weg, auf dem zwei Fassungen auseinanderlaufen — geübt hat dieses
 * Projekt das oft genug.
 *
 * `aria-label` und `title` tragen denselben Satz: der eine für die
 * Vorlesestimme, der andere für die Maus. In Worten steht die Bedeutung in
 * der Legende über der Teilnehmerliste — ein `title` ist auf dem Telefon
 * unsichtbar.
 */
export function Erreichbarkeit({
  push,
  stumm,
  size = 16,
}: {
  push: boolean
  stumm: boolean
  size?: number
}) {
  if (!push && !stumm) return null
  const text = stumm
    ? push
      ? 'Stummgeschaltet — Benachrichtigungen sind eingerichtet, kommen aber nicht an.'
      : 'Stummgeschaltet — und es sind keine Benachrichtigungen eingerichtet.'
    : 'Bekommt Benachrichtigungen.'
  return (
    <span className="erreichbarkeit" role="img" aria-label={text} title={text}>
      {stumm ? (
        push ? <GlockeAusIcon size={size} /> : <MondIcon size={size} />
      ) : (
        <GlockeIcon size={size} />
      )}
    </span>
  )
}
